import React, { useEffect, useState, useRef } from "react";
import ExcelExport from "../ExcelExport";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import moment from "moment";
export default function NewsTable() {
  const [prices, setPrices] = useState([]);
  const [filteredPrices, setFilteredPrices] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [todayMessage, setTodayMessage] = useState("Show todays values");

  //Pagination
  const [page, setPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(12);
  const getPrices = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/bulletin-news`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    const pricelist = await response.json();
    setPrices(pricelist);
    // console.log(prices)
  };

  const totalPages = Math.ceil(prices.length / postsPerPage);
  const pageRange = 10; // Number of page buttons to show at a time

  const startPage = Math.max(1, page - Math.floor(pageRange / 2));
  const endPage = Math.min(totalPages, startPage + pageRange - 1);

  const pageButtons = [...Array(endPage - startPage + 1)].map(
    (_, i) => startPage + i
  );
  useEffect(() => {
    getPrices();
  }, []);

  const lastPostIndex = page * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPrices = prices.slice(firstPostIndex, lastPostIndex);
  const selectPageHandler = (selectedPage) => {
    setPage(selectedPage);
  };

  //The Delete Button
  const handleDelete = async (itemId) => {
    const token = sessionStorage.getItem("token");
    const fL = prices.filter((filteredPrice) => filteredPrice._id !== itemId);
    await fetch(`${process.env.REACT_APP_API_URL}/delete-news/${itemId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    // .then(console.log("Delete successfull"))

    setPrices(fL);
  };

  const handleLinkedInPhotos = async () => {
    const todayDate = moment().format("YYYY-MM-DD");
    console.log(todayDate);
    await fetch(`${process.env.REACT_APP_API_URL}/todayNews/${todayDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // alert("LinkedIn photos have been generated");
    window.open(
      `${process.env.REACT_APP_API_URL}/todayNews/${todayDate}`,
      "_blank"
    ); // Opens in a new tab
  };

  // const handleLinkedInPhotosDownload = async () => {
  //   const todayDate = moment().format("YYYY-MM-DD");
  //   console.log(todayDate);
  //   await fetch(`${process.env.REACT_APP_API_URL}/bulk-screenshot`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   });
  // };

  const handleInsertIntoMongo = async () => {
    await fetch(`${process.env.REACT_APP_API_URL}/add-news`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    alert("news uploaded to mongodb");

    await getPrices();

  };

  const handleInstaPhotosGenerate = async () => {
    await fetch(`${process.env.REACT_APP_API_URL}/instaStory`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    window.open(`${process.env.REACT_APP_API_URL}/instaStory`, "_blank"); // Opens in a new tab
  };

  //edit page
  const navigate = useNavigate();
  //Edit page
  const handleEdit = async (itemId) => {
    navigate(`${process.env.REACT_APP_API_URL}/update/${itemId}`);
    // console.log("In the button")
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
        <h2 id="tabler">News</h2>
      </div>
      <div id="tabler1">
        <div className="tables-option-div">
          <div className="row">
            <div className="col">
              <div className="tables-options">
                <ExcelExport excelData={prices} fileName={"PricesSheet"} />
              </div>
            </div>

            <div className="col">
              <div className="tables-options">
                <Link to="/news-input">
                  {" "}
                  <button type="button" class="btn btn-secondary table-buttons">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-plus-square-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                    </svg>{" "}
                    Create New
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="tables-options">
                <Link onClick={handleLinkedInPhotos}>
                  {" "}
                  <button type="button" class="btn btn-secondary table-buttons">
                    {" "}
                    LinkedIn Photos Download
                  </button>
                </Link>
              </div>
            </div>
            {/* <div className="col">
              <div className="tables-options">
                <Link onClick={handleLinkedInPhotosDownload}>
                  {" "}
                  <button type="button" class="btn btn-secondary table-buttons">
                    {" "}
                    LinkedIn Photos Download
                  </button>
                </Link>
              </div>
            </div> */}
            <div className="col">
              <div className="tables-options">
                <Link onClick={handleInsertIntoMongo}>
                  {" "}
                  <button type="button" class="btn btn-secondary table-buttons">
                    {" "}
                    Insert into Mongo
                  </button>
                </Link>
              </div>
            </div>
            <div className="col">
              <div className="tables-options">
                <Link onClick={handleInstaPhotosGenerate}>
                  {" "}
                  <button type="button" class="btn btn-secondary table-buttons">
                    {" "}
                    Insta Photos
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="news-grid">
          {currentPrices &&
            currentPrices.map((price, index) => (
              <div class="card news-card" style={{ width: "18rem" }}>
                <img
                  class="card-img-top news-img"
                  src={price.image}
                  alt="Card image cap"
                />
                <div class="card-body">
                  <h5 class="card-title">{price.title}</h5>
                  <p class="card-text">
                    {price.excerpt.substring(0, 80) + "..."}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                      flexDirection: "column",
                    }}
                  >
                    <Link
                      type="button"
                      class="btn btn-info"
                      to={`/update-news/${price._id}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-pencil-square"
                        viewBox="0 0 16 16"
                      >
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path
                          fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                        />
                      </svg>{" "}
                      Edit{" "}
                    </Link>
                    <button
                      type="button"
                      class="btn btn-danger"
                      onClick={() => {
                        const userConfirmed = window.confirm(
                          "Are you sure you want to proceed?"
                        );
                        if (userConfirmed) {
                          handleDelete(price._id);
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />{" "}
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>{" "}
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {currentPrices.length > 0 && (
          <div className="pagination">
            <br />
            {pageButtons.map((pageNumber) => (
              <button
                type="button"
                id="num-but"
                class="btn btn-secondary btn-lg mb-2"
                onClick={() => selectPageHandler(pageNumber)}
                key={pageNumber}
              >
                {pageNumber}
              </button>
            ))}
            <br />
            {/**Fixing the date issue */}
          </div>
        )}
        {!prices && (
          <div class="alert alert-primary" role="alert">
            Oops! Something went wrong.
          </div>
        )}
      </div>
    </>
  );
}
